import { h } from 'preact'
import ContentCurationList from './ContentCurationList'
import ContentCurationItem from './ContentCurationItem'
import ArticleIcon from '../assets/icon-content-type-article'
import QuestionIcon from '../assets/icon-content-type-question'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import ProductUpdateIcon from '../assets/icon-product-update-type'
import IdeaIcon from '../assets/icon-content-type-idea'
import { GetServerSideProps } from 'js/src/server-middleware/context'
import { z } from 'zod'
import Unified from '../../services/unified'

interface CuratedTopicWithIconAndIdx {
  id: string
  type: 'conversation' | 'question' | 'article' | 'idea' | 'productUpdate'
  url: string
  title: string
  icon?: JSX.Element
  idx?: number
}

interface Props {
  curatedTopics: CuratedTopicWithIconAndIdx[]
  title: string
}

export const widgetName = 'recommendations'

export const config = z.object({
  title: z.string(),
  curatedTopics: z.number().array()
})

type Config = z.infer<typeof config>

function isCuratedContent (curatedTopic: CuratedTopicWithIconAndIdx|null): curatedTopic is CuratedTopicWithIconAndIdx {
  return !!curatedTopic
}

export const getServerSideProps: GetServerSideProps<Config, Props> = async (context, config) => {
  const unified = new Unified(context)
  const curatedTopics = await context.cache(`${JSON.stringify(config)}-${context.userId}`, async () => {
    return await unified.getTopicsIndexedByPublicId(config.curatedTopics)
  }, 60)

  return {
    title: config.title,
    curatedTopics: config.curatedTopics.map(topicId => {
      const topic = curatedTopics[topicId]
      if (!topic) {
        return null
      }
      return {
        id: topic.id.toString(),
        url: topic.url,
        title: topic.title,
        type: topic.contentType
      }
    }).filter(isCuratedContent)
  }
}

const Recommendations = ({ title, curatedTopics = [] }: Props) => {
  const topicType = {
    question: <QuestionIcon />,
    article: <ArticleIcon />,
    answer: <AnswerIcon />,
    discussion: <DiscussionIcon />,
    conversation: <DiscussionIcon />,
    productUpdate: <ProductUpdateIcon width={24} height={24} />,
    idea: <IdeaIcon />
  }

  if (!curatedTopics.length) {
    return null
  }

  return (
    <section className='topic-curation__container homepage-widget-wrapper full-width custom-featured-topic-list'>
      <div className='sitewidth'>
        <div className='col'>
          <div className='box__pad'>
            <h3 className='widget__heading m-b'>{title}</h3>
            {
            curatedTopics.length
              ? (
                <ContentCurationList>
                  {curatedTopics.map((item, idx) => {
                    item.icon = topicType[item.type]
                    item.idx = idx
                    return <ContentCurationItem key={item.id} {...item} />
                  })}
                </ContentCurationList>
                )
              : null
          }
          </div>
        </div>
      </div>
    </section>
  )
}

export default Recommendations
